export default __webpack_public_path__ + "static/media/infografico_linguagem_oral_e_processamento_fonologico.fefd6ad1.png";